import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Grid,
  makeStyles,
  Typography,
  useTheme,
} from "@material-ui/core";
import React, { useEffect } from "react";
import ColorButton from "components/common/ColorButton";
import Loading from "components/common/Loading";
import useModalLoading from "libs/hooks/useModalLoading";

const useStyles = makeStyles(() => ({
  card: {
    margin: 16,
  },
  content: {
    display: "flex",
    flexDirection: "row",
    margin: 10,
  },
}));

const Spacer = () => <div style={{ width: 10, display: "flex" }} />;

function Section({ title, children }) {
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardHeader title={title} />
      <Divider />
      <CardContent c>{children}</CardContent>
    </Card>
  );
}

function SectionButton() {
  const classes = useStyles();
  return (
    <Section title="Button">
      <Grid item className={classes.content}>
        <Button size="small" color="primary">
          Primary
        </Button>
        <Spacer />
        <Button variant="outlined" size="medium" color="primary">
          primary
        </Button>
        <Spacer />
        <Button variant="contained" size="large" color="primary">
          Primary
        </Button>
      </Grid>
      <Grid item className={classes.content}>
        <Button size="small" color="secondary">
          secondary
        </Button>
        <Spacer />
        <Button variant="outlined" size="medium" color="secondary">
          secondary
        </Button>
        <Spacer />
        <Button variant="contained" size="large" color="secondary">
          secondary
        </Button>
      </Grid>
      <Grid item className={classes.content}>
        <ColorButton size="small" color="success">
          success
        </ColorButton>
        <Spacer />
        <ColorButton variant="outlined" size="medium" color="success">
          success
        </ColorButton>
        <Spacer />
        <ColorButton variant="contained" size="large" color="success">
          success
        </ColorButton>
      </Grid>
      <Grid item className={classes.content}>
        <ColorButton size="small" color="info">
          info
        </ColorButton>
        <Spacer />
        <ColorButton variant="outlined" size="medium" color="info">
          info
        </ColorButton>
        <Spacer />
        <ColorButton variant="contained" size="large" color="info">
          info
        </ColorButton>
      </Grid>
      <Grid item className={classes.content}>
        <ColorButton size="small" color="warning">
          warning
        </ColorButton>
        <Spacer />
        <ColorButton variant="outlined" size="medium" color="warning">
          warning
        </ColorButton>
        <Spacer />
        <ColorButton variant="contained" size="large" color="warning">
          warning
        </ColorButton>
      </Grid>
      <Grid item className={classes.content}>
        <ColorButton size="small" color="error">
          error
        </ColorButton>
        <Spacer />
        <ColorButton variant="outlined" size="medium" color="error">
          error
        </ColorButton>
        <Spacer />
        <ColorButton variant="contained" size="large" color="error">
          error
        </ColorButton>
      </Grid>
    </Section>
  );
}

function ColorBox({ color, colorName }) {
  return (
    <div
      style={{
        // margin: 15,
        width: 400,
      }}
    >
      <Typography variant="p">{colorName}</Typography>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginTop: 8,
          alignItems: "center",
        }}
      >
        <div
          style={{
            marginRight: 8,
            width: 50,
            height: 50,
            backgroundColor: color,
          }}
        />
        <Typography variant="caption">{color}</Typography>
      </div>
    </div>
  );
}

function SectionColorPaletted() {
  const theme = useTheme();
  const classes = useStyles();
  return (
    <Section title="Color paletted">
      <Grid item className={classes.content}>
        <ColorBox colorName="primary" color={theme.palette.primary.main} />
      </Grid>
      <Grid item className={classes.content}>
        <ColorBox colorName="secondary" color={theme.palette.secondary.main} />
      </Grid>
      <Grid item className={classes.content}>
        <ColorBox colorName="success" color={theme.palette.success.main} />
      </Grid>
      <Grid item className={classes.content}>
        <ColorBox colorName="warning" color={theme.palette.warning.main} />
      </Grid>
      <Grid item className={classes.content}>
        <ColorBox colorName="error" color={theme.palette.error.main} />
      </Grid>
      <Grid item className={classes.content}>
        <ColorBox colorName="info" color={theme.palette.info.main} />
      </Grid>
    </Section>
  );
}

function SectionLoading() {
  const theme = useTheme();
  const classes = useStyles();
  const { showLoading, hideLoading } = useModalLoading();

  useEffect(() => {
    setTimeout(hideLoading, 3000);
  }, [hideLoading]);

  return (
    <Section title="Loading">
      <Grid item className={classes.content}>
        <Loading />
      </Grid>
      <Grid item className={classes.content}>
        <Button variant="outlined" onClick={() => showLoading()}>
          Show modal loading
        </Button>
      </Grid>
    </Section>
  );
}

export default function DesignSystemPage() {
  const classes = useStyles();
  return (
    <div>
      <Container maxWidth="xl">
        <Grid container>
          <SectionButton />
          <SectionColorPaletted />
        </Grid>
        <SectionLoading />
      </Container>
    </div>
  );
}
